export {Lang, configure, getConfig} from './utils/configure';
export type {StringWithSuggest} from './utils/types';
export * from './components';
export * from './hooks';
export * from './utils/dom';
